import { Button, Group, Stack, TextInput } from "@mantine/core";
import { useField } from "@mantine/form";
import { modals } from "@mantine/modals";
import { GeoLayer } from "shared/components/organization/geolocations/types";
import { GEO_QUERY_KEY } from "shared/components/organization/geolocations/useGeoLocations";
import { useGraphqlMutation } from "shared/hooks/useGraphql";
import { notify } from "shared/utils/notify";
import { graphql } from "src/gql";
import { queryClient } from "src/queryClient";

type AddLayerFormProps = {
    onCancel: () => void;
};

export const AddLayerForm = ({ onCancel }: AddLayerFormProps) => {
    const createLayer = useGraphqlMutation(muts.createLayer);

    const field = useField<string>({
        initialValue: "",
        validate: (value) => (value.trim() ? null : "Name is required"),
    });

    async function handleSubmit(event: React.FormEvent) {
        event.preventDefault();
        const error = await field.validate();
        if (error) return;

        const name = field.getValue().trim();

        void createLayer
            .mutateAsync({ name })
            .then((result) => {
                notify.show.success("Layer created");
                queryClient.setQueryData<GeoLayer[]>(GEO_QUERY_KEY, (old) =>
                    old ? [...old, { id: result.createGeoLayer.id, name }] : old,
                );
                modals.closeAll();
            })
            .catch(notify.catch);
    }

    return (
        <form onSubmit={(e) => void handleSubmit(e)}>
            <Stack>
                <TextInput label="Name" withAsterisk data-autofocus {...field.getInputProps()} />
                <Group justify="flex-end">
                    <Button variant="default" onClick={onCancel} disabled={createLayer.isPending}>
                        Cancel
                    </Button>
                    <Button type="submit" loading={createLayer.isPending} disabled={!field.getValue().trim()}>
                        Create
                    </Button>
                </Group>
            </Stack>
        </form>
    );
};

const muts = {
    createLayer: graphql(`
        mutation CreateGeoLayer($name: String!) {
            createGeoLayer(parameters: { name: $name }) {
                id
            }
        }
    `),
};
